var map = {
	"./1.png": 1499,
	"./10.png": 1500,
	"./2.png": 1501,
	"./3.png": 1502,
	"./4.png": 1503,
	"./5.png": 1504,
	"./6.png": 1505,
	"./7.png": 1506,
	"./8.png": 1507,
	"./9.png": 1508,
	"./answer.png": 808,
	"./background1.png": 807,
	"./background2.png": 806,
	"./background3.png": 805,
	"./background4.png": 804,
	"./ch1.png": 809,
	"./che1.png": 495,
	"./che2.png": 799,
	"./che3.png": 802,
	"./che4.png": 797,
	"./che5.png": 800,
	"./che6.png": 803,
	"./che7.png": 798,
	"./che8.png": 801,
	"./che9.png": 1509,
	"./complete.png": 796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;